import React, { ReactElement, useEffect, useState, useRef, useCallback } from 'react';
import { DI, DIProps } from '../../../Core';
import NoResultsFound from '../../../Asests/Images/NoResultsFound.png';
import { Badge, Button, Pagination, Link, Checkbox, ButtonGroup, Banner, EmptyState, Tooltip, Icon, Modal, InlineStack, Card, BlockStack, Text, Divider, List, Box, Popover, ActionList, TextContainer, ChoiceList, TextField } from '@shopify/polaris';
import Noimage from '../../../../public/files/noImage.png';
import GridActions from './Components/GridActions';
import TabsComponent from './Components/Tabs';
import { ChevronRightMinor, MobileCancelMajor, } from '@shopify/polaris-icons';
import SyncModal from './Components/SyncModal';
import { Table } from 'antd';
import { getAmazonLink } from '../Editproduct/utils/utils';
import GetTemplate from './Components/GetTemplate';
import { useTour } from '../../Other/tour';
import TourListingSteps from './Components/TourListingSteps';
import { apiData, gridColumns, gridFilters } from './Utilities/Constants';
import { allfilterI, columnInterface } from './Utilities/Interface';
import { newFormattedStatus, getShopID, DataToSend, modifyImageUrl, calculateProductStatus } from './Utilities/Helper';
import { useDebounce } from '../useDebounce';
import { GridApis } from './Utilities/Apis';
import ActionPopOver from './Components/ActionPopOver';
import StatusWiseAction from './Components/StatusWiseAction';
import './styles/styles.css';

import { rows as skeletonRows } from "./skeleton/TableSkeleton";
import { amazon_regions } from '../Onboarding/components/onboardinghelper';
import BulkUploadTourListing from './Components/BulkUploadTourListing';
import { useTranslation } from 'react-i18next';
import { cloneDeep } from 'lodash';
import Amazon from '../../../../src/Asests/Images/amazon.png';
import Shopify from '../../../../src/Asests/Images/shopify.png';
import ProductErrorsN from '../Editproduct/components/ProductDetails/ProductErrorsN';
import ProgressActivity from './Components/ProgressActivity';
import ProductWarningsN from '../Editproduct/components/ProductDetails/ProductWarningsN';
import { Tone } from '@shopify/polaris/build/ts/src/components/Badge';
import ActivityFeedsParent from './Components/ActivityFeedsParent';
import { LazyThumbnail } from "./../Editproduct/components/Image/Image"
import { isAdminLoggedIn } from '../Panel/index';
import FulfillmentType from '../Settings/Template/Components/FulfillmentType';
import getClass from '../../Utilities/getClass';
import GetLabel from './Components/GetLabel/GetLabel';
import SearchFeildUsingComboBox from './Components/SearchFeildUsingComboBox';
import ErrorModal from './Components/ErrorModal';

interface Props extends DIProps {
  syncNecessaryInfo: () => void;
  syncConnectorInfo: () => void;
  selectedRows?: any[];
}
/**
 * This component is responsible for the dashboard structure
 * @param props
 * @returns
 */

function ListingGrid(props: Props): ReactElement {
  const { t } = useTranslation();
  const { setCurrentStep, setTourLoading, setIsOpen, isOpen, currentStep } = useTour();


  const countPerPage: number = 50;
  const tableref = useRef<HTMLTableElement>(document.createElement("table"));
  const [textFieldValue, setTextFieldValue] = useState('');
  const [Rows, setRows] = useState<any[]>([]);
  const [page, setpage] = useState<number>(parseInt(props.di.globalState.get("inputpage", true) ?? "1"));
  const [loading, setloading] = useState<boolean>(true);
  const [DataforRow, setDataforRow] = useState<Array<any>>([]);
  const [totalPages, settotalPages] = useState<number>(0);
  const [nextPage, setnextPage] = useState();
  const [prevPage, setprevPage] = useState();
  const [selected, setSelected] = useState<number>(0);
  const [popover, setpopover] = useState<boolean>(false);
  const [totalProductCount, setTotalProductCount] = useState<number>(0);
  const [selectedRows, setselectedRows] = useState<Array<string>>([]);
  const [AmazonLokupLoading, setAmazonLokupLoading] = useState(false);
  const [SyncLoading, setSyncLoading] = useState<boolean>(false);
  const [queryValue, setqueryValue] = useState<string>('');
  const [selectedRowsChild, setselectedRowsChild] = useState([]);
  const [syncModal, setsyncModal] = useState(false);
  const [actiontype, setactiontype] = useState({});
  const [hasPrevious, sethasPrevious] = useState(false);
  const [hasNext, sethasNext] = useState(false);
  const [disableActions, setdisableActions] = useState(false);
  const [syncmodalLoading, setsyncmodalLoading] = useState(false);
  const [FiftyPlus, setFiftyPlus] = useState<boolean>(false)
  const [selectOpt, setSelectOpt] = useState<any>({
    options: [],
    manualIds: {}
  });
  const [activePlan, setActivePLan] = useState<string>("");
  let [lastActivities, setLastActivities] = useState<any>({});
  const [activateTour, setActivateTour] = useState(false);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [deleteModal, setdeleteModal] = useState<boolean>(false);
  const [select, setSelect] = useState<string[]>(['']);
  const [temp, settemp] = useState<any>([]);
  const [clonetemp, setclonetemp] = useState<any>([]);

  const [syncActionModal, setsyncActionModal] = useState(false)
  const [syncActionCheckbox, setsyncActionCheckbox] = useState<any>({
    inventory: false,
    price: false,
    image: false,
    loading: false
  })

  // const [LDModal, setLDModal] = useState({ open: false, selectedRows, selectedRowsChild })
  const [unformttedProductData, setUnformttedProductData] = useState<any>([]);
  const [modal, setModal] = useState<any>({
    isOpen: false,
    // description: " \n Error in refresh token.\n",
    title: 'Refresh Token',
    error: {}
  });
  const [allLabels, setAllLabels] = useState<any>([]);





  const [allFiltersNew, setallFilters] = useState<allfilterI>(
    Object.keys(JSON.parse(props.di.globalState.get(`${props.redux?.user_id}_${props.redux?.current?.target?._id}_filters`, true) ?? '{}'))?.length > 0 ?
      JSON.parse(props.di.globalState.get(`${props.redux?.user_id}_${props.redux?.current?.target?._id}_filters`, true) ?? '{}')
      :
      JSON.parse(JSON.stringify(gridFilters))
  );
  const [activeToast, setActiveToast] = useState({ open: false, refresh: false });
  const [columns, setColumns] = useState<columnInterface>([...gridColumns(t)]);
  // const [active, setActive] = useState(false);

  useEffect(() => {
    if (activePlan == "") setActivePLan(props.redux?.current_plan?.plan_details?.title)
  }, [props.redux?.current_plan])

  /**
   * use-effect to call refineProfucts call on filters, page, tabs, searchbox change
   */
  const debouncedQuery = useDebounce(queryValue, 1000);
  const debouncedFilters = useDebounce(props.di.globalState.get(`${props.redux?.user_id}_${props.redux?.current?.target?._id}_filters`, true), 1000);
  const debouncedInputPage = useDebounce(props.di.globalState.get("inputpage", true), 1000);
  const debouncedPagination = useDebounce(props.di.globalState.get('pagination', true), 1000);
  const debouncedTabs = useDebounce(props.di.globalState.get('tabs', true), 1000);
  useEffect(() => {
    page > 0 && fetchProductData();
    props?.di?.globalState?.removeLocalStorage("paginationVariant");
    props?.di?.globalState?.removeLocalStorage("filterVariant");
  }, [debouncedQuery, debouncedFilters, debouncedInputPage, debouncedPagination, debouncedTabs]);

  useEffect(() => {
    getProductCount();
  }, [debouncedFilters, debouncedInputPage, debouncedQuery]);

  useEffect(() => { checkWarehouseError() }, []);

  const filterSourceProductIds = (data: [], profile_id: string | undefined) => {
    let ids: any = {}
    if (data?.length > 0) {
      data?.map((product: any) => {
        if (product?.hasOwnProperty('source_product_id')) {
          ids = {
            ...ids,
            [product.source_product_id]: {
              ...(profile_id ? { "profile_id": profile_id } : {}),
              "product_status": product?.status ?? 'Not Listed',
              "listing_type": product?.status === 'Not Listed: Offer' ? 'offer_listing' : 'new_listing',
              "primary_category": ''
            }
          }
        }
      })
    }
    return ids
  }
  //API Call to fetch the Product data
  const fetchProductData = async (custom_filter: any = allFiltersNew) => {
    setLastActivities([])
    setloading(true);
    setdisableActions(true);
    setFiftyPlus(false);
    setselectedRows([])
    isOpen && setTourLoading(true)
    setselectedRowsChild([])
    // setDataforRow([])
    let paginationParam = getDataFromLocalStorage();
    let allFilter = filter(custom_filter);
    props.di.POST(`${GridApis.getRefineProducts}`, {
      filter: allFilter,
      productOnly: true,
      sortBy: '_id',
      count: countPerPage,
      ...paginationParam,
      cif_amazon_multi_project: apiData
    })
      .then((products) => {
        setdisableActions(false);
        if (products.success) {
          setnextPage(products?.['data']['next']);
          setprevPage(products?.['data']['prev']);
          setloading(false);
          setDataforRow(products?.data?.rows);
          !props.di.globalState.get("inputpage", true) && sethasPrevious(
            products?.['data']['prev'] == null ? false : true
          );
          !props.di.globalState.get("inputpage", true) && sethasNext(
            products?.['data']['next'] == null ? false : true
          );
          if (!activateTour && products?.data?.rows.length > 0 && props.di.globalState.get('start_tour') === 'single_product_upload') {
            const part = JSON.parse(props.di.globalState.get('uploadTour') ?? '{}')?.part;
            (part == '1' || part == '3') && setActivateTour(true);
          } else if (activateTour && products?.data?.rows.length > 0 && props.di.globalState.get('start_tour') === 'single_product_upload' && currentStep === 2) {
            setTimeout(() => {
              isOpen && setTourLoading(false)
              setCurrentStep(a => +a + 1);
            }, 500)
          } else {
            if (props.di.globalState.get('start_tour') === 'single_product_upload' && !activateTour && products?.data?.rows.length <= 0) {
              props.error(t('No products for uploading'))
              props?.di.globalState?.removeLocalStorage('start_tour');
            }
          }
          if (isOpen && props.di.globalState.get('start_tour') === 'bulk_upload_2' && products?.data?.rows.length > 0 && currentStep < 5 && !!custom_filter?.['Template name']?.textValue) {
            setCurrentStep(a => a + 1)
          }
          if (isOpen && props.di.globalState.get('start_tour') === 'bulk_upload_2' && products?.data?.rows.length <= 0) {
            setCurrentStep(9)
            // props.error('No products for uploading')
            // props?.di.globalState?.removeLocalStorage('start_tour');
            // setIsOpen(false)
          }
          isOpen && setTourLoading(false)
        } else {
          if (isOpen) {
            setTourLoading(false)
            setCurrentStep(-1)
            setIsOpen(false)
            props.error(t('Cannot proceed with tour as no products are found.'))
          }
        }
      });
  };

  //API Call to get product count API fetch
  const getProductCount = (custom_filter: any = allFiltersNew) => {
    let allFilter = filter(custom_filter);
    props.di.POST(`${GridApis.getRefineProductCount}`, {
      filter: allFilter,
    }).then((Data) => {
      if (Data.success) {
        setTotalProductCount(Data.data.count);
        if (Data.data.count > 0) {
          handleTotalpage(Data['data']['count']);
        } else if (Data.data.count == 0) {
          handleTotalpage(Data['data']['count']);
        }
      }
      else props.error(t(Data?.message))
    })
  };

  // function to render UI for badges


  // this function is responsible for calculating total page count
  const handleTotalpage = (totalPages: number) => {
    if (totalPages > 0) {
      if (totalPages % countPerPage == 0) {
        totalPages = totalPages / countPerPage;
      } else {
        totalPages = Math.trunc(totalPages / countPerPage) + 1;
      }
      window.scrollTo(0, 0);
      settotalPages(totalPages);
      if (totalPages < page) {
        setpage(1)
        sethasPrevious(false)
      }
      else if (totalPages == page)
        sethasNext(false)
      else if (totalPages > page)
        sethasNext(true)
    }
    else {
      window.scrollTo(0, 0);
      settotalPages(0);
    }
  };



  /**
   * Component to render Amazon activities
   * @param row
   * @returns
   */
  const GetActivityFromRowData = ({ row, type }: any) => {
    const [errorModal, openErrorModal] = useState<boolean>(false);
    const [ActivityProgressModal, setActivityProgressModal] = useState(false);
    const [warningPopover, setWarningPopover] = useState<boolean>(false);
    const [warningData, setWarningData] = useState<boolean>(false);

    const { has_flags = {} } = row || {};
    const { has_error, has_progress, has_warning } = has_flags;

    // Helper to render Badge with optional click handler
    const renderBadge = (tone: Tone, content: string, onClick?: () => void) => (
      <span className={`grid${content}Badge`} onClick={onClick}>
        <Badge progress="incomplete" tone={tone}>{t(content)}</Badge>
      </span>
    );

    // Helper to render Popover with Warning badge
    const renderWarningPopover = () => (
      <Popover
        active={warningPopover}
        activator={
          <Button variant="plain" onClick={() => setWarningPopover(!warningPopover)} size="micro" disclosure>+1</Button>
        }
        autofocusTarget="first-node"
        onClose={() => setWarningPopover(false)}
      >
        <ActionList
          actionRole="menuitem"
          items={[
            {
              content: "",
              badge: { content: t('Warning'), tone: "new" },
              onAction: () => setWarningData(true),
            }
          ]}
        />
      </Popover>
    );

    // Render activity based on flags
    let renderData: JSX.Element = <Text as='p' tone='subdued'><em>{t("No Ongoing Activity")}</em></Text>;

    if (has_error && has_progress && has_warning) {
      renderData = (
        <BlockStack align='center' gap="100">
          <InlineStack align='center' gap="200">
            {renderBadge("critical", "Error", () => openErrorModal(true))}
            {renderWarningPopover()}
          </InlineStack>
          <Text as='p' tone="subdued"><i>{t("task in progress")}</i></Text>
        </BlockStack>
      );
    } else if (has_error && has_progress && !has_warning) {
      renderData = (
        <BlockStack align='center' gap="100">
          <InlineStack align='center' gap="200">
            {renderBadge("critical", "Error", () => openErrorModal(true))}
          </InlineStack>
          <Text as='p' tone="subdued"><i>{t("task in progress")}</i></Text>
        </BlockStack>
      );
    } else if (has_error && !has_progress && has_warning) {
      renderData = (
        <InlineStack align='center' gap="200">
          {renderBadge("critical", "Error", () => openErrorModal(true))}
          {renderWarningPopover()}
        </InlineStack>
      );
    } else if (!has_error && has_progress && has_warning) {
      renderData = (
        <BlockStack align='center' gap="100">
          <InlineStack align='center' gap="200">
            {renderBadge("warning", "Warning", () => setWarningData(true))}
          </InlineStack>
          <Text as='p' tone="subdued"><i>{t("task in progress")}</i></Text>
        </BlockStack>
      );
    } else if (has_error && !has_progress && !has_warning) {
      renderData = (
        <BlockStack align='center' gap="100">
          <InlineStack align='center' gap="200">
            {renderBadge("critical", "Error", () => openErrorModal(true))}
          </InlineStack>
        </BlockStack>
      );
    } else if (!has_error && has_progress && !has_warning) {
      renderData = (
        <BlockStack gap="100">
          <div>
            <span className='gridInProgressBadge' onClick={() => setActivityProgressModal(true)}>
              <Badge tone="success" progress="complete" size="small">{t("In Progress")}</Badge>
            </span>
          </div>
          <Text as='p' tone="subdued"><i>{t("task in progress")}</i></Text>
        </BlockStack>
      );
    } else if (!has_error && !has_progress && has_warning) {
      renderData = (
        <BlockStack align='center' gap="100">
          <InlineStack align='center' gap="200">
            {renderBadge("warning", "Warning", () => setWarningData(true))}
          </InlineStack>
        </BlockStack>
      );
    }

    return (
      <React.Fragment>
        <div className='activity'>{renderData}</div>
        <ErrorModal
          type={type}
          id={row?.['container_id']}
           activityRefreshAction={activityRefreshAction}
          viewProductError={errorModal || warningData || ActivityProgressModal}
          setViewProductError={errorModal ? openErrorModal : warningData ? setWarningData : ActivityProgressModal ? setActivityProgressModal : null}
        ></ErrorModal>
        {/* <ErrorModalTemp
          type={type}
          id={row?.['container_id']}
          viewProductError={errorModal}
          setViewProductError={openErrorModal}
        /> */}
        {/* <ProductErrorsN
          from='grid'
          type={type}
          id={row?.['container_id']}
          viewProductError={errorModal}
          setViewProductError={openErrorModal}
        /> */}
        {/* <ProductWarningsN
          from='grid'
          type={type} d
          id={row?.['container_id']}
          viewProductWarning={warningData}
          setViewProductWarning={setWarningData}
        />
        <ProgressActivity
          ActivityProgressModal={ActivityProgressModal}
          setActivityProgressModal={setActivityProgressModal}
          activityRefreshAction={activityRefreshAction}
          {...props}
          from='grid'
          type={type}
          id={row?.['container_id']}
        /> */}
      </React.Fragment>
    );
  };



  // function to get prepare Inventory count and msg based on its num of variants


  const getNumofVarients = (row: any) => {
    if (row?.items) {
      if (row?.variant_count == 1) {
        return t('No variants')
      }
      else {
        return row?.variant_count <= 2 ? `${row?.variant_count - 1} variant` : `${row?.variant_count - 1} ${t("variants")}`;
      }
    }
  }



  //  Function prepare data to show in Product Details column in a grid
  const getDatafromRow = (row: any, data: string) => {
    let Data = "";
    if (data == 'asin') {
      let temp: any = "";
      if (row?.items) {
        if (row?.type != 'simple') {
          row?.items?.map((item: any, idx: number) => {
            if (item?.source_product_id == row.source_product_id) {
              temp = item?.[data] ? item?.[data]?.length === 10 && /^[a-zA-Z][a-zA-Z0-9]*$/.test(data)
                ? <Link target='_blank' key={idx} onClick={() => window.open(`https://${getAmazonLink(props)}/dp/${item?.asin}`)}>{item?.asin}</Link> : <Text as='span'  >{item?.[data]}</Text> : <Text as='span' tone="subdued" >N/A</Text>
              return temp
            }
          });
        }
        else {
          temp = row?.items[0]?.[data] ? row?.items[0]?.[data]?.length == 10 && /^[a-zA-Z][a-zA-Z0-9]*$/.test(data) ? <Link target='_blank' onClick={() => window.open(`https://${getAmazonLink(props)}/dp/${row?.items[0]?.[data]}`)}>{row?.items[0]?.[data]}</Link> : <Text as='span'  >{row?.items[0]?.[data]}</Text> : <Text as='span' tone="subdued" >N/A</Text>
          return temp;
        }
      }
    }
    else if (data == 'fulfillment_type') {
      if (row?.items) {
        return row?.items[0]?.[data]
      }
    }
    else if (data == 'shopify_sku') {
      if (row?.items) {
        return row?.items[0]?.[data]
      }
    }
    else {
      if (row?.items) {
        if (row?.type != 'simple') {
          return row?.items.map((item: any) => {

            if (item?.source_product_id == row.source_product_id) {
              return item?.[data]
            }
          })?.filter((a: string | undefined) => !!a && a)?.[0] ?? undefined
        } else {

          return row?.items[0]?.[data]
        }
      }
    }

    return Data;
  }



  const RenderSKU = ({ row }: any) => {
    let returnJSX: ReactElement = <></>
    // let badge: any = newFormattedStatus(row, getShopID(props));
    let badge: any = calculateProductStatus(row?.status, row?.type)
    if (['Active', 'Inactive', 'Incomplete', 'Listed', 'Partial Listed', 'Partial Uploaded', "Uploaded"].includes(badge?.label)) {
      <Text as='span'>{badge?.emptyStatus ? t("Not Listed") : t("Listed")}</Text>
      if (!badge?.emptyStatus) {
        returnJSX = (<BlockStack gap={'200'}>
          <InlineStack gap={'200'}>
            <img alt='amazon' height={'20px'} width={'20px'} src={Amazon} />
            <Text as='span' tone="subdued">{getDatafromRow(row, "sku") || t("N/A")}</Text>
          </InlineStack>
          {getDatafromRow(row, "shopify_sku") && <InlineStack gap={'200'}>
            <img alt='shopify' height={'20px'} width={'20px'} src={Shopify} />
            <Text as='span' tone="subdued">{getDatafromRow(row, "shopify_sku") || t("N/A")}</Text>
          </InlineStack>}
        </BlockStack>)

      } else {
        returnJSX = (
          <BlockStack gap={'200'}>
            <InlineStack gap={'200'}>
              <img alt='shopify' height={'20px'} width={'20px'} src={Shopify} />
              <Text as='span' tone="subdued">{getDatafromRow(row, "sku") || t("N/A")}</Text>
            </InlineStack>
            {getDatafromRow(row, "shopify_sku") && <InlineStack gap={'200'}>
              <img alt='shopify' height={'20px'} width={'20px'} src={Shopify} />
              <Text as='span' tone="subdued">{getDatafromRow(row, "shopify_sku") || t("N/A")}</Text>
            </InlineStack>}
          </BlockStack>
        )


      }


    } else {
      returnJSX =
        <BlockStack gap={'200'}>
          <InlineStack gap={'200'}>
            <img alt='shopify' height={'20px'} width={'20px'} src={Shopify} />
            {/* <Text as='p'>{t("SKU")}:</Text> */}
            <Text as='span' tone="subdued">{getDatafromRow(row, "sku") || t("N/A")}</Text>
          </InlineStack>
          {getDatafromRow(row, "shopify_sku") && <InlineStack gap={'200'}>
            <img alt='shopify' height={'20px'} width={'20px'} src={Shopify} />
            {/* <Text as='p'>{t("SKU")}:</Text> */}
            <Text as='span' tone="subdued">{getDatafromRow(row, "shopify_sku") || t("N/A")}</Text>
          </InlineStack>}
        </BlockStack>
    }

    return returnJSX;
  }

  const RenderProductLinkingStatus = ({ row }: any) => {
    if (row?.items?.[0]?.shopify_sku) {
      return (
        <Badge tone='magic'>Linked</Badge>
      )
    } else {
      return <></>
    }
  }

  useEffect(() => {
    props.di.GET("shopifyhome/request/getLabels", { count: true })
      .then((res: any) => {
        if (res?.success) {
          setAllLabels(res?.data);
        }
        // else {
        //   props.error("Labels not found.");
        // }
      });
  }, []);

  //grid prepration use effect
  useEffect(() => {
    let TempData: any = [];
    let tempKeySelected: any = [];
    let current_shop_currency: any = amazon_regions.filter((value: any) => value?.currency == props?.redux?.current?.source?.currency)?.[0];
    // setselectedRows([]);
    DataforRow.length > 0 &&
      DataforRow.forEach((row: any, count) => {
        FiftyPlus ? tempKeySelected.push(row?.source_product_id) : null;
        const newData: any = {
          key: row?.source_product_id,
          image: (
            <div className="custom-product-img__container">
              {/* <img width="100%" height="100%" src={row?.main_image ? modifyImageUrl(row.main_image) : Noimage} alt="product" /> */}
              {/* <img width="100%" height="100%" src={row?.main_image ? modifyImageUrl(row.main_image) : Noimage} alt="product" /> */}
              <LazyThumbnail
                src={row?.items?.[0]?.main_image ? modifyImageUrl(row?.items?.[0]?.main_image) : Noimage}
                alt='productImages'
                key={row?.items?.[0]?.main_image ? modifyImageUrl(row?.items?.[0]?.main_image) : Noimage + 'Thumbnail' + Math.random()}
                size='medium'
              />
            </div>
          ),
          sku: <RenderSKU row={row}></RenderSKU>,
          productDetails: (
            <BlockStack gap="100">
              {row?.type == "simple" ?
                <>
                  <Text as='p'>{t("Shopify Price:")}{" "}{<Text as='span' tone="subdued" >{getDatafromRow(row, "price") >= 0 ? ` ${current_shop_currency?.['currency_symbol']}${getDatafromRow(row, "price")}` : t("N/A")}</Text>}  </Text>
                  <InlineStack gap={'025'}>
                    <Text as='p'>{t("Barcode")}:</Text>
                    <Text as='span' tone="subdued" >  {getDatafromRow(row, "barcode") || t("N/A")}</Text>
                  </InlineStack>
                  <InlineStack>
                    <Text as='p'>{`${t("ASIN")}: `}</Text><Text as='span' tone="subdued">{getDatafromRow(row, "asin") || t("N/A")}</Text>
                  </InlineStack>
                  <InlineStack>
                    <Text as='p'>{t("Fulfilment")} :{<Text as='span' tone="subdued">{getDatafromRow(row, "fulfillment_type") || t("FBM")}</Text>}</Text>
                  </InlineStack>
                </> : <InlineStack>
                  <Text as='p' tone='subdued'>{t("N/A")}</Text>
                </InlineStack>
              }

            </BlockStack>
          ),
          product_title: row?.title,
          title: (
            <React.Fragment>
              <BlockStack inlineAlign='start'>
                {(
                  <div
                    className="product_title"
                    onClick={() => {
                      if (isOpen) {
                        props.di.POST('connector/config/saveConfig',
                          {
                            data: [{
                              data: JSON.parse(JSON.stringify({ listing_tour_1_visited: true, listing_tour_2_visited: false })),
                              group_code: 'tour',
                            }]
                          }).then((response: any) => {
                            setCurrentStep(-1);
                            setIsOpen(false);
                            setActivateTour(false);
                            props.di.globalState.set('uploadTour', JSON.stringify({ part: '2' }));
                            if (response.success)
                              return;
                          });
                      }
                      props.history(`.${"/new"}/${row['container_id']}`, {
                        state: {
                          source_product_id: row.source_product_id ?? row.container_id ?? '',
                          status: row,
                          errorExists: row.has_flags?.has_error,
                          progressExists: row.has_flags?.has_progress,
                          warningExists: row.has_flags?.has_warning,
                        }
                      });
                      props.di.globalState.removeLocalStorage('edit_tour_current_step');
                    }}
                    style={{ cursor: 'pointer' }}
                  >
                    {typeof row?.title != 'object' ? row?.title : ''}
                  </div>
                )
                }
                {/* <RenderProductLinkingStatus row={row}></RenderProductLinkingStatus> */}

              </BlockStack>

            </React.Fragment >
          ),
          quantity: getInventoryQuantity(row, t),//old
          // quantity: row?.type !== 'simple' ? row?.variant_count > 1 ? `${row?.quantity} ${t("in stock ")} ` : `${row?.quantity || "0"} ${t("in stock")} ` : `${row?.quantity || "0"} ${t("in stock")}`,
          variants: getNumofVarients(row) === t("No variants") ? <Text as='p' variant='bodyMd' tone='subdued'>{t("No Variants")}</Text> : <Link onClick={() => {
            props.di.globalState.removeLocalStorage("filtersVariants")
            props.history('variants', {
              state: {
                ai_updated_product: row?.items?.[0]?.ai_updated_product,
                container_id: row?.container_id,
                title: typeof row?.title != 'object' ? row?.title : '',
                fulfillment_type: row?.items?.[0]?.fulfillment_type ?? false,
                image: row?.main_image ? modifyImageUrl(row.main_image) : Noimage,
                status: newFormattedStatus(row, getShopID(props)),
                errorExists: row.has_flags?.has_error ?? false,
                parentData: row,
                progressExists: row.has_flags?.has_progress ?? false,
                warningExists: row.has_flags?.has_warning ?? false,
              }
            });
          }}>
            <InlineStack wrap={false} gap={"100"}>
              <span style={{ whiteSpace: "pre" }}>{getNumofVarients(row)}</span><span className='flex'><Icon source={ChevronRightMinor} /></span>
            </InlineStack></Link>,
          status: <div className='status'><SetBadge t={t} {...props} item={row} /></div>,
          template:
            <React.Fragment>
              {<div className="Custom__Template--Name">
                <GetTemplate t={t} row={row} selectOpt={selectOpt} activityRefreshAction={activityRefreshAction} />
              </div>}
            </React.Fragment>,
          activity: <GetActivityFromRowData row={row} type={'parent'} />,
          feed: <ActivityFeedsParent row={row} lastActivities={lastActivities} setLastActivities={setLastActivities} />,
          action: (
            <InlineStack gap="200">
              <StatusWiseAction
                syncModal={syncModal}
                setactiontype={setactiontype}
                setsyncModal={setsyncModal}
                row={row}
                // setLDModal={setLDModal}
                {...props}
              />
            </InlineStack>
          ),
          type: row?.type,
          container_id: row?.container_id,
          varients: row?.items?.filter((value: any) => value?.source_product_id != row?.source_product_id),
          profile: row?.profile ? row?.profile : null,
          source_product_id: row?.source_product_id,
          all_images: row?.all_images
        };

        // Append the 'label' field after 'template' **only if the admin is logged in**
        if (isAdminLoggedIn() || process.env.REACT_APP_PROD === "0") {
          newData.label = <GetLabel {...props} row={row} allLabels={allLabels} selectedLabels={row?.assigned_labels ?? []} activityRefreshAction={activityRefreshAction} />;
        }

        // Push data to TempData
        TempData.push(newData);
      });

    FiftyPlus && setselectedRows(tempKeySelected);
    setRows(TempData);
  }, [DataforRow, lastActivities, selectOpt, allLabels]);

  //useEffect for hiding the table

  useEffect(() => {
    if (selectedRows.length > 0 || selectedRowsChild.length > 0) {
      tableref.current?.classList.add("header-hidden");
    } else {
      tableref.current?.classList.remove("header-hidden");
    }
  }, [selectedRows, selectedRowsChild]);

  // preparation of the filter query
  const filter = (custom_filter: allfilterI = allFiltersNew) => {
    let filterdata: any = {};
    Object.keys(custom_filter).forEach((key: string) => {
      let tempData: any = {};
      if (custom_filter?.[key]?.change) {
        if (key === 'Optimised' && custom_filter?.[key]?.textValue === 'false') tempData[2] = true;
        else tempData[custom_filter?.[key]?.selectValue] = custom_filter?.[key]?.textValue;
      }
      if (Object.keys(tempData).length > 0) filterdata[custom_filter?.[key]?.value] = tempData
    });
    return filterdata;
  };

  //this function gets pagination data from local storage
  const getDataFromLocalStorage = () => {
    let param: any = {};
    let val: any = props.di.globalState.get('pagination', true);
    val = JSON.parse(val);
    if (val) {
      Object.keys(val).forEach((key) => {
        if (key != '1') {
          setpage(parseInt(key))
          if (Object.keys(val?.[key]).includes('next')) {
            setnextPage(val?.[key]['next'] ?? '');
            // param = `&next=${val?.[key]['next']}`;
            param = { next: val?.[key]['next'] };
          } else if (Object.keys(val?.[key]).includes('prev')) {
            setprevPage(val?.[key]['prev'] ?? '');
            // param = `&prev=${val?.[key]['prev']}`;
            param = { prev: val?.[key]['prev'] };
          }
        }
      });
    }
    else if (props.di.globalState.get("inputpage", true)) {
      page > 1 && sethasPrevious(true);
      page == 1 && sethasPrevious(false);
      // param = `&activePage=${props.di.globalState.get("inputpage", true)}`
      param = { activePage: props.di.globalState.get("inputpage", true) }
    }
    return param;
  };

  const checkWarehouseError = async () => {
    let { success, data, msg } = await props.di.POST("amazon/request/checkWarehouse", {
      group_code: ["inventory"]
    })
    if (success) {
      if (data && Object.keys(data).length > 0) {
        setModal({ ...modal, isOpen: true, title: 'Attention', error: data })
      }
    }
  }






  //this function handle the pagination next event
  const handlePaginationNext = () => {
    if (props.di.globalState.get("inputpage", true)) {
      if (page < totalPages) {
        setpage(page + 1);
        props.di.globalState.set("inputpage", (page + 1).toString())
      }
      else sethasNext(false)
    }
    else if (nextPage != null) {
      sethasNext(false);
      props.di.globalState.removeLocalStorage("inputpage");
      sethasPrevious(false);
      let temp: any = {};
      temp[page + 1] = { next: nextPage };
      props.di.globalState.set('pagination', JSON.stringify(temp), true);
      setpage(page + 1);
    }
  };

  //this function handle the pagination previous event
  const handlePaginationPrevious = () => {
    if (props.di.globalState.get("inputpage", true)) {
      if (page > 1) {
        setpage(page - 1);
        props.di.globalState.set("inputpage", (page - 1).toString())
      }
      else sethasPrevious(false)
    }
    else if (prevPage != null) {
      sethasPrevious(false);
      sethasNext(false);
      if (page > 1) {
        let temp: any = {};
        temp[page - 1] = { prev: prevPage };
        props.di.globalState.set('pagination', JSON.stringify(temp), true);
        setpage(page - 1);
      } else {
        let temp: any = {};
        temp[page - 1] = {};
        props.di.globalState.set('pagination', JSON.stringify(temp), true);
        setpage(page - 1);
      }
    }
  };

  //this function is used to amazonLookup bulk action which search the product on amazon
  const amazonLookupBulk = () => {
    setAmazonLokupLoading(true);
    props.di.POST(GridApis.searchProduct, { ...DataToSend(props) })
      .then((response) => {
        setAmazonLokupLoading(false);
        response.success ? props.success(t(response.message)) : props.error(t(response.message));
      });
  };

  //need to implement the shop details via Props or redux
  const amazonSync = (payload: any = false) => {
    setSyncLoading(true);
    let params: any = {
      ...DataToSend(props),
      'data': {
        matchWith: 'sku',
        initiated: 'manual'
      }
    };

    if (payload) params['data']['importProduct'] = true;
    props.di.POST(GridApis.matchProduct, params).then((response) => {
      setSyncLoading(false);
      response.success ? props.success(t(response.message)) : props.error(t(response.message));
    });
  };

  //this is the activator button which is used to display the accordian in the frontend section
  const activator = (
    <Button disclosure onClick={() => {
      setpopover(!popover)
      if (isOpen) {
        setCurrentStep(a => +a + 1);
        setTourLoading(true)
        const interval = setInterval(() => { setTourLoading(false) }, 500)
        return () => { clearInterval(interval) }
      }
    }} id='popoverActivator' >
      {t("Select Actions")}
    </Button >
  );

  // Function to execute API calls for Amazon Sync Actions
  const syncAction = (Data: any, source_product_id = undefined) => {
    setsyncActionCheckbox({
      ...syncActionCheckbox,
      loading: true
    })
    let url: string = '';
    let temp: any = [];
    let data: any = {};
    setsyncmodalLoading(true);
    setTourLoading(true);
    if (selectedRows.length > 0) {
      if (selectedRowsChild.length > 0) {
        temp.push(...selectedRowsChild)
      }
      temp.push(...selectedRows)
    }
    else temp.push(selectedRowsChild)
    let SourceProductIds: Array<string> = FiftyPlus ? [] : source_product_id == undefined ? selectedRows.length > 0 ? temp.length !== 0 ? temp : selectedRows : selectedRowsChild : [source_product_id];
    let params: any = {
      ...DataToSend(props),
      source_product_ids: SourceProductIds,
      // limit: SourceProductIds.length,
      activePage: 1,
    };
    FiftyPlus ? params['profile_id'] = 'all_products' : null;
    Object.keys(allFiltersNew)?.map((key: any) => {
      if (allFiltersNew[key].change) {
        data[allFiltersNew[key]['value']] = {
          [allFiltersNew[key]?.['selectValue']]: allFiltersNew[key]?.['textValue']
        }
      }
    });
    if (Object.keys(data).length > 0 && FiftyPlus) {
      delete params['profile_id'];
      params['filter'] = data
      params['useRefinProduct'] = true;
    }

    FiftyPlus && delete params['source_product_ids'];
    // FiftyPlus ? DataToSend['limit'] = '500' : null
    switch (Data) {
      case 'Sync Product':
        url = 'connector/product/productSync';
        params['filter'] = {
          ...params['filter'],
          "items.status": {
            "10": ["Inactive", "Incomplete", "Active", "Uploaded"]
          }
        }
        break;
      case 'Sync Inventory':
        url = 'connector/product/inventorySync';
        params['filter'] = {
          ...params['filter'],
          "items.status": {
            "10": ["Inactive", "Incomplete", "Active", "Uploaded"]
          }
        }

        break;
      case 'Amazon Lookup':
        url = 'connector/product/searchProduct';
        break;
      case 'Sync Price':
        url = 'connector/product/priceSync';
        params['filter'] = {
          ...params['filter'],
          "items.status": {
            "10": ["Inactive", "Incomplete", "Active", "Uploaded"]
          }
        }
        break;
      case 'Sync Image':
        url = 'connector/product/imageSync';
        params['filter'] = {
          ...params['filter'],
          "items.status": {
            "10": ["Inactive", "Incomplete", "Active", "Uploaded"]
          }
        }
        break;
      case 'Delete Product':
        url = 'connector/product/deleteFromMarketplace';
        params['filter'] = {
          ...params['filter'],
          "items.status": {
            "10": ["Inactive", "Incomplete", "Active", "Uploaded"]
          }
        }
        break;
      case 'Unified':
        url = 'connector/product/group';

        const actionMap: any = {
          price: 'price_sync',
          inventory: 'inventory_sync',
          image: 'image_sync',
        };

        const selectedActions = Object.keys(syncActionCheckbox || {})
          .filter(key => syncActionCheckbox[key])
          .map(key => actionMap[key]);

        // Fully reinitializing `params` for Unified case
        let unifiedParams: any = {
          ...DataToSend(props),
          source_product_ids: FiftyPlus
            ? []
            : source_product_id == undefined
              ? selectedRows.length > 0
                ? temp.length !== 0
                  ? temp
                  : selectedRows
                : selectedRowsChild
              : [source_product_id],
          activePage: 1,
          "operationType": "groupAction",
          "groupWiseAction": selectedActions
        };

        if (FiftyPlus) {
          unifiedParams['profile_id'] = 'all_products';
          Object.keys(allFiltersNew || {}).forEach((key: any) => {
            if (allFiltersNew[key].change) {
              data[allFiltersNew[key]['value']] = {
                [allFiltersNew[key]['selectValue']]: allFiltersNew[key]['textValue']
              };
            }
          });
          if (Object.keys(data).length > 0) {
            delete unifiedParams['profile_id'];
            unifiedParams['filter'] = data;
            unifiedParams['useRefinProduct'] = true;
          }
          delete unifiedParams['source_product_ids'];
        }

        // Adding default item status filter
        unifiedParams['filter'] = {
          ...unifiedParams['filter'],
          "items.status": {
            "10": ["Inactive", "Incomplete", "Active", "Uploaded"]
          }
        };

        unifiedParams['useRefinProduct'] = true;
        unifiedParams['usePrdOpt'] = true;
        unifiedParams['projectData'] = { marketplace: 0 };

        // Replace the outer `params` with this for Unified
        params = unifiedParams;

        break;
      case 'Upload Product':
        url = 'connector/product/upload';
        break;
    }
    params['useRefinProduct'] = true;
    if (url !== 'connector/product/searchProduct') {
      params['usePrdOpt'] = true;
      params['projectData'] = { 'marketplace': 0 };
    }

    props.di.POST(url, params).then((response) => {
      setsyncActionCheckbox({
        loading: false,
        inventory: false,
        price: false,
        image: false
      })

      if (response.success) {
        let filter: any = { ...allFiltersNew };
        setsyncModal(false);
        setsyncmodalLoading(false);
        if (isOpen) {
          setTourLoading(true)
          setCurrentStep(a => +a + 1)
        }
        setpopover(!popover);
        props.success(t(response.message));
        let selected = JSON.parse(props.di.globalState?.get('selected_for_tour') ?? '{}')?.selected
        if (isOpen && selected) {
          filter = {
            ...gridFilters,
            "Container_id": { "value": "container_id", "textValue": selected?.container_id, "type": "Title", "searchvalue": selected?.product_title, "selectValue": "1", "change": true },
          }
          setallFilters({ ...filter })
          props.di.globalState.set(`${props.redux?.user_id}_${props.redux?.current?.target?._id}_filters`, JSON.stringify({ ...filter }), true)
          props.di.globalState.removeLocalStorage('selected_for_tour')
        }
        activityRefreshAction(filter)
        setselectedRowsChild([])
        setselectedRows([])
      } else {
        setsyncModal(false);
        setpopover(!popover);
        if (isOpen) {
          setTourLoading(true)
          setCurrentStep(a => +a + 1)
        }
        setsyncmodalLoading(false);
        props.error(t(response.message == "Target shop is not active." ? "Your account is inactive or there is some problem with your account." : response.message));
      }
      setsyncActionModal(false)
    });
  };

  const handleTextFieldChange = useCallback(
    (value: string) => {
      setTextFieldValue(value);
      if (value == "") settemp(JSON.parse(JSON.stringify(clonetemp)));
      else {
        let abc = temp.map((ele: any) => {
          if (ele.label.toLowerCase().includes(value.toLowerCase())) return ele;
        }).filter(Boolean);
        settemp(abc);
      }
    },
    [temp],
  );
  // function to handle Fifty Plus
  const handleFiftyPlus = () => {
    let TempRow: any = []
    Rows.forEach((row: any) => { TempRow.push(row?.source_product_id) })
    setselectedRows(TempRow);
    setselectedRowsChild([])
    setFiftyPlus(true)
  }

  // functon to perform refresh action on listing Grid
  const activityRefreshAction = (custom_filter: any = allFiltersNew) => {
    fetchProductData(custom_filter);
    getProductCount(custom_filter);
  };

  const handleHeaderSelectAll = (row: any) => {

    if (selectedRows.length > 0 && selectedRows.length == DataforRow.length) {
      setselectedRows([]);
      setselectedRowsChild([]);
    }
    else if (row.length > 0 && DataforRow.length > row.length) {
      let rowTempData: any = [];
      Rows.map((row: any) => rowTempData.push(row?.source_product_id));
      setselectedRows(rowTempData);
    }
  }

  const [latestData, setLatestData] = useState<any>("{}");


  const wsRef = useRef<WebSocket | null>(null);
  const [lastActivity, setLastActivity] = useState<number>(Date.now());

  useEffect(() => {
    const connect = async () => {
      if (!wsRef.current || wsRef.current.readyState === WebSocket.CLOSED) {
        wsRef.current = new WebSocket('wss://a5zls8ce93.execute-api.us-east-2.amazonaws.com/beta');
        wsRef.current.onopen = () => {
          const clientIdString: string | undefined = process.env.REACT_APP_WEBSOCKET_CLIENT_ID;
          if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN && clientIdString) {
            const dataTosend: any = {
              "action": "identity", "client_id": parseInt(clientIdString), "customer_id": props.di.globalState.get("user_id"),
              "token": props.di.globalState.getBearerToken()
            }
            wsRef.current.send(JSON.stringify(dataTosend));
          }
          setActiveToast({ ...activeToast, open: false })
        };

        wsRef.current.onmessage = (event) => {

          // Triggering the onDataReceived function here
          setLatestData(event.data);
        };

        wsRef.current.onerror = (error) => {
          console.error('WebSocket error:', error);
        };

        wsRef.current.onclose = () => {
          if (Date.now() - lastActivity > 600000) { // 30 minutes in milliseconds
            setActiveToast({ ...activeToast, open: true })
          } else {
            connect();
          }
        };
      }
    };

    connect();

    return () => {
      if (wsRef.current) {
        wsRef.current.close();
      }
    };
  }, [activeToast.refresh]);

  const handleclose = () => {
    fetchProductData()
    getProductCount();
    setActiveToast({ open: false, refresh: !activeToast.refresh })
  }

  useEffect(() => {
    if (latestData) {
      if (Array.isArray(JSON.parse(latestData)?.notification)) {
        const updatedData = DataforRow.map((data: any) => {
          let feedItem = JSON.parse(latestData)?.notification?.find((element: any) => data?.container_id === element?.container_id);
          if (feedItem) {
            let updatedDataItem = { ...data };
            let tempHasFlag: any = {};
            if (feedItem.unset) {
              const unsetItem = feedItem.unset;
              Object.keys(unsetItem).forEach((key: string) => {
                if (key == 'process_tags') {
                  tempHasFlag = {
                    'has_progress': false
                  };
                } if (key == 'error') {
                  updatedDataItem.has_flags = {
                    'has_error': false
                  };

                } if (key == 'warning') {
                  updatedDataItem.has_flags = {
                    'has_warning': false
                  };

                }


              });
              updatedDataItem = {
                ...updatedDataItem,
                has_flags: { ...tempHasFlag }
              }

            }
            if (feedItem.error) {
              updatedDataItem.has_flags = {
                ...updatedDataItem.has_flags,
                has_error: true,
              };
            }
            if (feedItem?.process_tags) {
              updatedDataItem.has_flags = {
                ...updatedDataItem.has_flags,
                has_progress: true,
              };

            }
            if (feedItem?.warning) {
              updatedDataItem.has_flags = {
                ...updatedDataItem.has_flags,
                has_warning: true,
              };
            }
            return updatedDataItem;
          } else {
            return { ...data };
          }
        });
        setDataforRow(updatedData);
      }
    }
  }, [latestData, loading]);


  const DataToSendNew = (type: string) => {
    let allSame: boolean = false;
    let data: any = {};
    let Newids: any[] = [];
    let deleteids: any[] = []
    let profileids: any[] = []
    let containerIds: any[] = []
    let deleteContainerIds: any[] = []
    DataforRow.map((ele) => {
      if (ele?.profile == '' || ele?.profile?.type !== 'query') {
        Newids.push(ele?.source_product_id)
      };
    })

    const commonValues = Newids.filter(value => selectedRows.includes(value));

    commonValues.forEach((val1) => {
      DataforRow.map((ele2) => {
        if (ele2?.source_product_id == val1) {
          containerIds?.push(ele2?.container_id)
        }
      })
    })
    if (type == 'change') {
      data = {
        "data": {
          "_id": select.toString(),
          "type": "profile",
          "manual_product_ids": containerIds
        }
      }
    }
    else {
      DataforRow.map((element) => {
        if (element?.profile && Object.values(element?.profile)?.length > 0) {
          if (element?.profile?.type !== 'query') {
            deleteids.push(element?.source_product_id)
          };
        }
      })
      const commonDeleteValues = deleteids.filter(value => selectedRows.includes(value));
      commonDeleteValues.forEach(val => {
        DataforRow.map((ele1) => {
          if (ele1?.source_product_id == val) {
            profileids?.push(ele1?.profile?.profile_id?.['$oid'])
            deleteContainerIds.push(ele1.container_id);
          }
        })

      });
      allSame = profileids?.every(value => value === profileids[0]);
      if (allSame && profileids?.length > 0) {
        data = {
          "data": {
            "_id": profileids[0]?.toString(),
            "type": "profile",
            "manual_product_ids": deleteContainerIds
          }
          , "delete": true
        }
      }
    }

    return { data, allSame };
  }


  const actionOnTemplate = (type: string) => {
    setloading(!loading)
    let { data, allSame } = DataToSendNew(type)
    console.log(allSame);
    props.di.POST(GridApis.savePartialChunk, data)
      .then((res: any) => {
        if (res?.success) {
          if (type === 'save')
            props.success(t('Template added to the product.'))
          else if (type === 'change')
            props.success(t('Product assigned to the selected template.'))
          else if (type = 'delete')
            props.success(t('Template removed from the product.'))
          setloading(loading)
          activityRefreshAction()
        } else if (!allSame) {
          props.error(t('Removing different templates is not supported. Please select products with the same template.'))
          setloading(loading)
        }
        else if (type = 'delete') {
          props.error(t('Template Not Found'))
          setloading(loading)
        }

      })
      .catch((error) => {
        props.error(t(error));
        console.error(error);
      });
    setTimeout(() => {
      // setOpenModal({ open: false, modalHead: "" })
      // setSelectTemplateOpt("")
    }, 800)
  }
  const handleChange = useCallback((value: string[]) => setSelect(value), []);
  function changetemplate() {
    setOpenModal(!openModal);
    actionOnTemplate('change');
    //  const a=  DataToSendNew('change');
    //  console.log(a,'hgjhgcgdaf')
  }
  function deletetemplate() {
    setdeleteModal(!deleteModal);
    actionOnTemplate('delete');
    //  const a=  DataToSendNew('delete');
    //  console.log(a,'hgjhgcgdaf')

    // console.log('template')
  }
  function SyncUnifiedData() {
    setsyncActionModal(false);

    const actionMap: any = {
      price: 'price_sync',
      inventory: 'inventory_sync',
      image: 'image_sync',
    };

    const selectedActions = Object.keys(syncActionCheckbox || {}).filter(
      key => syncActionCheckbox[key]
    ).map(key => actionMap[key]);

    const payload = {
      operationType: selectedActions
    };

    props.di.POST("connector/product/group", payload).then(data => {
      if (data?.success) {
        const defaultMessage = selectedActions.length
          ? `${selectedActions.map(action => {
            if (action === 'price_sync') return 'Price';
            if (action === 'inventory_sync') return 'Inventory';
            if (action === 'image_sync') return 'Image';
            return '';
          }).filter(Boolean).join(' and ')} sync initiated`
          : "Sync initiated";

        props.success(data?.message || defaultMessage);
      } else {
        props.error(data?.message ?? "Something went wrong");
      }
    });
  }


  const renderTable = () => {
    if (DataforRow.length > 0 || loading) {
      return (
        <div className='table-wrapper' id="tour">
          <BlockStack gap="300" align='center'>
            <BlockStack gap="200">
              <Card padding="0">
                <Table
                  className='custom-listing-grid-table'
                  sticky
                  ref={tableref}
                  // loading={loading}
                  size="middle"
                  id="tour_grid"
                  scroll={{ x: 700 }}
                  pagination={false}
                  columns={columns}
                  dataSource={(!loading && Rows.length > 0) ? Rows : skeletonRows}
                  rowSelection={{
                    onSelect: (value, _, selected) => {
                      if (isOpen) props.di.globalState.set('selected_for_tour', JSON.stringify({ selected: selected[0] }))
                      let temp = [...selectedRows];
                      setFiftyPlus(false);
                      if (temp.includes(value?.key)) {
                        temp.splice(temp.indexOf(value['key']), 1);
                      } else temp.push(value['key']);
                      setselectedRows([...temp]);
                    },
                    onSelectAll: (value, rows) => {
                      setFiftyPlus(false);
                      let temp: Array<any> = [];
                      rows.forEach((row) => temp.push(row?.key))
                      setselectedRows([...temp]);
                      if (isOpen) setCurrentStep(a => a + 1)
                    },
                    selectedRowKeys: selectedRows
                  }}
                  summary={() =>
                    selectedRows.length > 0 ?
                      <Table.Summary fixed="top">
                        <Table.Summary.Row>
                          <Table.Summary.Cell index={0} colSpan={11}>
                            <div className="toolbar" style={{ backgroundColor: '#fafafa', padding: '9px' }}>
                              <InlineStack gap="400" blockAlign="center" align="start">
                                <ButtonGroup variant="segmented">
                                  <Button
                                    size="slim"
                                    icon={<Checkbox
                                      onChange={(value) => handleHeaderSelectAll(selectedRows)}
                                      checked={selectedRows.length < DataforRow.length ? 'indeterminate' : true}
                                      label='' labelHidden
                                    />}
                                    loading={loading}>
                                    {FiftyPlus ? `50+ ${t("Selected")}` : `${selectedRowsChild.length > 0 ? selectedRows.length + selectedRowsChild.length : selectedRows.length} ${t("Selected")}`}
                                  </Button>
                                  <Button
                                    onClick={() => {
                                      setselectedRows([]);
                                      setFiftyPlus(false);
                                      setselectedRowsChild([])
                                    }}
                                    size="medium"
                                    icon={MobileCancelMajor}
                                  />
                                </ButtonGroup>
                                {totalPages > 1 &&
                                  <InlineStack gap="100">
                                    {!FiftyPlus &&
                                      <Button onClick={handleFiftyPlus} size="medium" variant="plain">
                                        {t("Select all 50+ products")}
                                      </Button>
                                    }
                                    {FiftyPlus && <Text as="p">{t("All 50+ products are selected.")}</Text>}
                                    {
                                      FiftyPlus && (
                                        <Button
                                          onClick={() => {
                                            setFiftyPlus(false);
                                            setselectedRows([]);
                                            setselectedRowsChild([])
                                          }}
                                          variant="plain">
                                          {t("Undo")}
                                        </Button>
                                      )}
                                  </InlineStack>
                                }
                                <ActionPopOver
                                  setOpenModal={setOpenModal}
                                  setdeleteModal={setdeleteModal}
                                  type={"parentRow"}
                                  t={t}
                                  setsyncActionModal={setsyncActionModal}
                                  activityRefreshAction={activityRefreshAction}
                                  inProgress={isOpen}
                                  currentStep={currentStep}
                                  popover={popover}
                                  setpopover={setpopover}
                                  activator={activator}
                                  setactiontype={setactiontype}
                                  setsyncModal={setsyncModal}
                                  setLoading={setTourLoading}
                                  setCurrentStep={setCurrentStep}
                                  // setLDModal={setLDModal}
                                  selectedRows={selectedRows}
                                  selectedRowsChild={selectedRowsChild}
                                  templateNew={(e: any) => { settemp(e); setclonetemp(e) }}
                                />
                              </InlineStack>
                            </div>
                          </Table.Summary.Cell>
                        </Table.Summary.Row>
                      </Table.Summary>
                      :
                      selectedRowsChild.length > 0 ?
                        <Table.Summary fixed="top">
                          <Table.Summary.Row>
                            <Table.Summary.Cell index={0} colSpan={11}>
                              <div className="toolbar" style={{ backgroundColor: '#fafafa', padding: '9px' }}>
                                <InlineStack gap="400" blockAlign="center" align="start">
                                  <ButtonGroup variant="segmented">
                                    <Button
                                      size="slim"
                                      icon={<Checkbox
                                        onChange={() => handleHeaderSelectAll(selectedRowsChild)}
                                        checked={selectedRows.length < DataforRow.length ? 'indeterminate' : true}
                                        label='' labelHidden
                                      />}
                                      loading={loading}>
                                      {
                                        FiftyPlus ? '50+ Selected' : `${selectedRows.length > 0 ? selectedRows.length + selectedRowsChild.length : selectedRowsChild.length} selected`
                                      }
                                    </Button>
                                    <Button
                                      onClick={() => {
                                        setselectedRows([]);
                                        setselectedRowsChild([]);
                                        setFiftyPlus(false);
                                      }}
                                      size="medium"
                                      icon={MobileCancelMajor}
                                    />
                                  </ButtonGroup>
                                  {totalPages > 1 &&
                                    <InlineStack gap="100">
                                      {!FiftyPlus &&
                                        <Button onClick={handleFiftyPlus} size="medium" variant="plain">
                                          Select all 50+ products
                                        </Button>
                                      }
                                      {FiftyPlus && <Text as="p">All 50+ products are selected.</Text>
                                      }
                                      {FiftyPlus && (
                                        <Button
                                          onClick={() => {
                                            setFiftyPlus(false);
                                            setselectedRows([]);
                                            setselectedRowsChild([]);
                                          }}
                                          variant="plain">
                                          Undo
                                        </Button>
                                      )}
                                    </InlineStack>
                                  }
                                  <ActionPopOver
                                    setOpenModal={setOpenModal}
                                    setdeleteModal={setdeleteModal}
                                    setsyncActionModal={setsyncActionModal}
                                    type={"ChildRow"}
                                    inProgress={isOpen}
                                    currentStep={currentStep}
                                    popover={popover}
                                    setpopover={setpopover}
                                    activator={activator}
                                    setactiontype={setactiontype}
                                    setsyncModal={setsyncModal}
                                    setLoading={setTourLoading}
                                    setCurrentStep={setCurrentStep}
                                    // setLDModal={setLDModal}
                                    selectedRows={selectedRows}
                                    selectedRowsChild={selectedRowsChild}
                                    templateNew={(e: any) => { settemp(e); setclonetemp(e) }}
                                  />
                                </InlineStack>
                              </div>
                            </Table.Summary.Cell>
                          </Table.Summary.Row>
                        </Table.Summary>
                        : null
                  }
                />
              </Card>
              <InlineStack align="center" gap="400">
                <Pagination
                  label={
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <div className="Polaris-TextField">
                        <input
                          className="psedu-polaris-textfield Polaris-TextField__Input Polaris-TextField__Input--alignCenter"
                          style={{ maxWidth: '50px' }}
                          type='number'
                          min="1"
                          placeholder={'placeholder'}
                          onBlur={() => {
                            if (page == 0) {
                              setpage(1)
                            }
                          }}
                          onChange={(value: any) => {
                            props.di.globalState.removeLocalStorage("pagination")
                            const inputValue = value.target.value.trim(); // No parseInt here
                            let pageValue: number = 0
                            if (inputValue != "") {
                              const parsedInput = parseInt(inputValue);
                              if (!isNaN(parsedInput)) {
                                if (parsedInput < 1) {
                                  pageValue = 1;
                                } else if (parsedInput > totalPages) {
                                  pageValue = totalPages;
                                } else {
                                  pageValue = parsedInput;
                                }
                              }
                            }
                            props.di.globalState.set("inputpage", pageValue.toString())
                            setpage(pageValue)
                          }}
                          value={page}
                        />
                        <div className="Polaris-TextField__Backdrop"></div>
                      </div>
                      <div style={{ margin: '0 0 0 10px' }}>
                        <Text as='span' tone="subdued">{` / ${totalPages} ${t("page(s)")}`}</Text>
                      </div>
                    </div>
                  }
                  hasPrevious={hasPrevious}
                  onPrevious={handlePaginationPrevious}
                  hasNext={hasNext}
                  onNext={handlePaginationNext}
                />
              </InlineStack>
            </BlockStack>
          </BlockStack>
        </div>
      );
    } else {
      return (
        <InlineStack align="center">
          <EmptyState image={NoResultsFound} heading={t('No Products Found')} />
        </InlineStack>
      );
    }
  };
  const [appliedFilters, setAppliedFilters] = useState<any>({});
  const handleClearAllFilters = useCallback(() => {
    let tempData = { ...allFiltersNew };
    setTourLoading(
      Object.values({ ...allFiltersNew })?.some(
        (value: any) => !!value?.change
      )
    );
    Object.keys(tempData).forEach((key) => {
      if (tempData[key].change) {
        tempData[key].textValue = '';
        tempData[key].change = false;
      }
    });
    setallFilters(tempData);
    props.di.globalState.removeLocalStorage(`${props.redux?.user_id}_${props.redux?.current?.target?._id}_filters`);
    setAppliedFilters([]);
  }, []);
  const handleCheckboxChange = (key: string) => {
    setsyncActionCheckbox((prev: any) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const isAnyChecked = Object.values(syncActionCheckbox || {}).some(Boolean);


  return (

    <React.Fragment>
      <TourListingSteps
        start={DataforRow.length > 0 || loading}
        selectedLength={selectedRows.length + selectedRowsChild.length}
        activateTour={activateTour}
        setActivateTour={setActivateTour}
        rows={DataforRow}
        selected={selected}
      />
      <BulkUploadTourListing />
      {/* <Button onClick={()=> setActive((active)=> !active)}>Get Feedback form</Button> */}
      {/* <FeedbackForm active={active} setActive={setActive}/> */}
      <BlockStack gap="400">
        {/* {DataforRow.length > 0 && <Box paddingInlineStart="400" paddingBlock="200" background='bg-fill-secondary-hover' borderRadius='200'>
                    <InlineStack gap="300" blockAlign="center">
                        <Text variant="bodySm" as="p" fontWeight="medium">
                            Need any help in Uploading a product?
                        </Text>
                        <Button icon={PlayMajor}
                            disabled={loading}
                            onClick={() => {
                                !activateTour &&
                                    setActivateTour(true);
                                !activateTour &&
                                    props.di.globalState.set(
                                        'uploadTour',
                                        JSON.stringify({
                                            part: '1',
                                        })
                                    );
                                handleClearAllFilters();
                            }}>
                            Start Product Upload Tour
                        </Button>
                    </InlineStack>
                </Box>} */}
        <div className="Custom-Alpha-Card">
          {(
            <Card padding="0" roundedAbove="sm">
              <TabsComponent
                {...props}
                setallFilters={setallFilters}
                allFiltersNew={allFiltersNew}
                setSelected={setSelected}
                selected={selected}
                loading={setloading}
              />
              <div className="Custom-Alpha-Card">
                <Box
                  paddingInlineStart="400"
                  paddingInlineEnd="400"
                  paddingBlockEnd="400">
                  <BlockStack gap="300">
                    <Divider />
                    <GridActions
                      {...props}
                      // totalProductCount={totalProductCount}
                      setappliedFilters={setAppliedFilters}
                      appliedFilters={appliedFilters}
                      handleClearAllFilters={handleClearAllFilters}
                      columns={columns}
                      selectedRows={selectedRows}
                      disableActions={disableActions}
                      Rows={Rows}
                      activityRefreshAction={activityRefreshAction}
                      AmazonLokupLoading={AmazonLokupLoading}
                      queryValue={queryValue}
                      filterapplied={filter}
                      selectedFlag={selectedRows}
                      selectedFlagChild={selectedRowsChild}
                      setqueryValue={setqueryValue}
                      SyncLoading={SyncLoading}
                      amazonLookupBulk={amazonLookupBulk}
                      amazonSync={amazonSync}
                      FilterQuery={filter}
                      allFiltersNew={allFiltersNew}
                      setallFiltersNew={setallFilters}
                      setSelectOpt={setSelectOpt}
                      gridLoading={loading}
                    />
                    {<Divider />}
                    {renderTable()}
                  </BlockStack>
                </Box>
              </div>
            </Card>
          )}
        </div>
      </BlockStack>

      {syncModal && Object.keys(actiontype).length > 0 && (
        <SyncModal
          {...props}
          t={t}
          syncmodalLoading={syncmodalLoading}
          actiontype={actiontype}
          syncAction={syncAction}
          syncModal={syncModal}
          setsyncModal={setsyncModal}
          totalProdCount={totalProductCount}
          FiftyPlus={FiftyPlus}
          activePlan={activePlan}
        />
      )}

      <Modal
        open={modal?.isOpen}
        primaryAction={{
          content: 'Close',
          onAction: () => {
            modal.isOpen = false;
            setModal({ ...modal });
          },
        }}
        onClose={() => {
          modal.isOpen = false;
          setModal({ ...modal });
        }}
        title={modal?.title}>
        <Modal.Section>
          {modal?.description && <Banner tone="warning">{modal?.description}</Banner>}
          {Object.keys(modal.error ?? {})?.length > 0 && (
            <Banner tone="warning">
              <Text as="p">Selected warehouse disabled in the Product Template - Please choose an active warehouse for these templates. :</Text>
              <List type="bullet">
                {Object.keys(modal.error).length > 0 &&
                  Object.keys(modal.error ?? {}).map(
                    (index: any) => {
                      return (
                        <List.Item key={index}>
                          {modal?.error?.[index] ==
                            'Product Settings' ? (
                            <Button
                              onClick={() => props.history('../config/productSettings/inventory')}
                              variant="plain">
                              {modal?.error?.[index]}
                            </Button>
                          ) : (
                            <Button
                              onClick={() => props.history('../config/template/' + index)}
                              variant="plain">
                              {modal?.error?.[index]}
                            </Button>
                          )}
                        </List.Item>
                      );
                    }
                  )}
              </List>
            </Banner>
          )}
        </Modal.Section>
      </Modal>

      {Object.keys(temp)?.length > 0 ? <Modal
        open={openModal}
        primaryAction={{
          content: t('Save'),
          onAction: () => {
            changetemplate()
          },
        }}
        onClose={() => {
          setOpenModal(false);
        }}
        secondaryActions={[
          {
            content: t('Cancel'),
            onAction: () => {
              setOpenModal(false);
            },
          },
        ]}
        title={t('Assign Template')}>
        <Modal.Section>
          <TextField
            label="Tagged with"
            value={textFieldValue}
            onChange={handleTextFieldChange}
            placeholder={t("Search by Template name")}
            autoComplete="off"
            labelHidden
          />
          {<Banner tone="warning">{t('Note: This only works on manually added product templates, and it will also override the existing template on the product after saving. It works on 50 products at a time.')}
          </Banner>}
          <ChoiceList
            title={t("Template's List")}
            choices={temp}
            selected={select}
            onChange={handleChange}
          />
        </Modal.Section>
      </Modal> :
        <Modal
          open={openModal}
          onClose={() => {
            setOpenModal(false);
          }}
          title={t('Assign Template')}>
          <Modal.Section>
            <TextField
              label="Tagged with"
              value={textFieldValue}
              onChange={handleTextFieldChange}
              placeholder={t("Search by Template name")}
              autoComplete="off"
              labelHidden
            />
            {<Banner tone="warning">"{("Note: This only works on manually added product templates, and it will also override the existing template on the product after saving.It works on 50 products at a time.")}"
            </Banner>}
            <Text as={'p'} >{t("No templates created!")}</Text>
          </Modal.Section>
        </Modal>
      }
      <Modal
        open={deleteModal}
        primaryAction={{
          content: t('Unassign'),
          onAction: () => {
            deletetemplate()
          },
        }}
        onClose={() => {
          setdeleteModal(false);
        }}
        secondaryActions={[
          {
            content: t('Cancel'),
            onAction: () => {
              setdeleteModal(false);
            },
          },
        ]}
        title={t("Unassign Template")}>
        <Modal.Section>
          {<Banner tone="warning">{t("Note: This will unassign the template from all selected products. It only works if all selected products have the same template, and the template has manually assigned products.")}</Banner>}
        </Modal.Section>
      </Modal>

      <Modal
        open={syncActionModal}
        size="small"
        primaryAction={{
          content: t('Proceed'),
          onAction: () => {
            const selectedActions = Object.entries(syncActionCheckbox)
              .filter(([key, value]) => key !== 'loading' && value)
              .map(([key]) => key);

            let payload = 'Unified';

            if (selectedActions.length === 1) {
              const actionMap: any = {
                price: 'Sync Price',
                image: 'Sync Image',
                inventory: 'Sync Inventory'
              };
              payload = actionMap[selectedActions[0]];
            }

            syncAction(payload);
          },
          disabled: !isAnyChecked,
          loading: syncActionCheckbox?.loading
        }}
        onClose={() => {
          setsyncActionCheckbox({
            inventory: false,
            price: false,
            image: false,
            loading: false
          });
          setsyncActionModal(false)
        }}
        secondaryActions={[
          {
            content: t('Cancel'),
            onAction: () => {
              setsyncActionCheckbox({
                inventory: false,
                price: false,
                image: false,
                loading: false
              }); setsyncActionModal(false)
            },
          },
        ]}
        title={t("Sync Actions")}
      >
        <Modal.Section>
          <InlineStack gap="1200" align="start">
            <Checkbox
              checked={syncActionCheckbox?.inventory}
              onChange={() => handleCheckboxChange('inventory')}
              label="Inventory"
            />
            <Checkbox
              checked={syncActionCheckbox?.price}
              onChange={() => handleCheckboxChange('price')}
              label="Price"
            />
            <Checkbox
              checked={syncActionCheckbox?.image}
              onChange={() => handleCheckboxChange('image')}
              label="Image"
            />
          </InlineStack>
        </Modal.Section>
      </Modal>


    </React.Fragment>

  );
}


export const getInventoryQuantity = (row: any, t: any) => {
  if (row?.items) {
    if (row?.type == "simple") {
      return (`${row?.quantity} ${t('in stock') || t('0 in stock')}`);
    }
    else {
      return row?.variant_count <= 2 ? `${row?.quantity} ${t("in stock for")} ${row?.variant_count - 1} ${t("variant")}` : `${row?.quantity} ${t("in stock for")} ${row?.variant_count - 1} ${t("variants")}`;
    }
  }
};

export function SetBadge(props: any) {
  const { item, t } = props;
  let renderBadge: JSX.Element = (
    <Tooltip
      content={
        <div style={{ width: "130px" }}>
          <BlockStack gap="200">
            <BlockStack gap="100">
              <Text as="p" fontWeight="semibold">
                {t("BADGE_INFO")}
              </Text>
              <InlineStack gap="100" blockAlign="center">
                <Text as="span">{t('SIMPLE_NOT_LISTER')}</Text>
              </InlineStack>
            </BlockStack>
          </BlockStack>
        </div>
      }
      dismissOnMouseOut
    >
      <Badge>{t("Not Listed")}</Badge>
    </Tooltip>
  );
  let badge: any = calculateProductStatus(item?.status, item?.type)

  // let badge: any = newFormattedStatus(item, getShopID(props));
  switch (badge?.label) {
    case 'Partial Listed':
      renderBadge = (
        <Tooltip content={
          <div style={{ width: "130px" }}>
            <BlockStack gap="200">
              <BlockStack gap="100">
                <Text as='p' fontWeight='semibold'>{t("PRODUCT")}</Text>
                <InlineStack gap="100" blockAlign='center'>
                  <span className={badge?.emptyStatus ? "Polaris-Badge-Pip Polaris-Badge-Pip--progressComplete" : "Polaris-Badge-Pip Polaris-Badge--toneSuccess Polaris-Badge-Pip--progressComplete"} />
                  <Text as='span'>{badge?.emptyStatus ? t("Not Listed") : t("Listed")}</Text>
                </InlineStack>
              </BlockStack>
              <Divider />
              <BlockStack gap="100">
                <Text as='p' fontWeight='semibold'>{t("VARIANTS")}</Text>
                <InlineStack gap="100" blockAlign='center'>
                  <span className="Polaris-Badge-Pip Polaris-Badge--toneSuccess Polaris-Badge-Pip--progressComplete" />
                  <Text as='span'>{`${t("Listed")} (${badge?.variant_count || 0})`}</Text>
                </InlineStack>
                <InlineStack gap='100' blockAlign='center'>
                  <span className={"Polaris-Badge-Pip Polaris-Badge-Pip--progressComplete"} />
                  <Text as='span'>{`${("Not Listed ")}(${badge?.not_listed_count || 0})`}</Text>
                </InlineStack>
              </BlockStack>
            </BlockStack>
          </div>
        } dismissOnMouseOut>
          <span className={getClass({
            "Custom--listed-Product-Badge": true,
            "Custom--listed-Product-Badge-windows": navigator.userAgent.includes('Windows')
          })}>
            <Badge tone='success' progress='partiallyComplete' >{t(badge?.['label'])}</Badge>
          </span>
          <span className={badge?.emptyStatus ? 'Custom--Empty-Icon Custom--listed-icon' : 'Custom_Icon Custom--listed-icon'}></span>
        </Tooltip>
      );
      break;

    case 'Listed':
      renderBadge = (
        <Tooltip content={
          <div style={{ width: "130px" }}>
            <BlockStack gap="200">
              <BlockStack gap="100">
                <Text as='p' fontWeight='semibold'>{t("PRODUCT")}</Text>
                <InlineStack gap="100" blockAlign='center'>
                  <span className={badge?.emptyStatus ? "Polaris-Badge-Pip Polaris-Badge-Pip--progressComplete" : "Polaris-Badge-Pip Polaris-Badge--toneSuccess Polaris-Badge-Pip--progressComplete"} />
                  <Text as='span'>{badge?.emptyStatus ? t("Not Listed") : t("Listed")}</Text>
                </InlineStack>
              </BlockStack>
              <Divider />
              <BlockStack gap="100">
                <Text as='p' fontWeight='semibold'>{t("VARIANTS")}</Text>
                <InlineStack gap="100" blockAlign='center'>
                  <span className="Polaris-Badge-Pip Polaris-Badge--toneSuccess Polaris-Badge-Pip--progressComplete" />
                  <Text as='span'>{`${t("Listed")} (${badge?.variant_count || 0})`}</Text>
                </InlineStack>
                <InlineStack gap='100' blockAlign='center'>
                  <span className={"Polaris-Badge-Pip Polaris-Badge-Pip--progressComplete"} />
                  <Text as='span'>{`${t("Not Listed")} (${badge?.not_listed_count || 0})`}</Text>
                </InlineStack>
              </BlockStack>
            </BlockStack>
          </div>
        } dismissOnMouseOut>
          <span className={getClass({
            "Custom--listed-Product-Badge": true,
            "Custom--listed-Product-Badge-windows": navigator.userAgent.includes('Windows')
          })}>
            <Badge tone='success' progress='complete' >{t(badge?.['label'])}</Badge>
          </span>
          <span className={badge?.emptyStatus ? 'Custom--Empty-Icon Custom--listed-icon' : 'Custom_Icon Custom--listed-icon'}></span>
        </Tooltip>
      )
      break;

    case 'Not Listed':
      if (item?.type !== "simple")
        renderBadge = (
          <Tooltip content={
            <div style={{ width: "130px" }}>
              <BlockStack gap="200">
                <BlockStack gap="100">
                  <Text as='p' fontWeight='semibold'>{t("BADGE_INFO")}</Text>
                  <InlineStack gap="100" blockAlign='center'>
                    <Text as='span'>{t('NOT_LISTER')}</Text>
                  </InlineStack>
                </BlockStack>
                <Divider />
                <BlockStack gap="100">
                  <Text as='p' fontWeight='semibold'>{t("PRODUCT")}</Text>
                  <InlineStack gap="100" blockAlign='center'>
                    <span className={badge?.emptyStatus ? "Polaris-Badge-Pip Polaris-Badge-Pip--progressComplete" : "Polaris-Badge-Pip Polaris-Badge--toneSuccess Polaris-Badge-Pip--progressComplete"} />
                    <Text as='span'>{t("Not Listed")}</Text>
                  </InlineStack>
                </BlockStack>
                <Divider />
                <BlockStack gap="100">
                  <Text as='p' fontWeight='semibold'>{t("VARIANTS")}</Text>
                  <InlineStack gap="100" blockAlign='center'>
                    <span className={badge?.variant_count > 0 ? "Polaris-Badge-Pip Polaris-Badge--toneSuccess Polaris-Badge-Pip--progressComplete" : "Polaris-Badge-Pip Polaris-Badge-Pip--progressComplete"} />
                    <Text as='span'>{`${t("Listed ")}(${badge?.variant_count || 0})`}</Text>
                  </InlineStack>
                  <InlineStack gap='100' blockAlign='center'>
                    <span className={"Polaris-Badge-Pip Polaris-Badge-Pip--progressComplete"} />
                    <Text as='span'>{`${t("Not Listed")} (${badge?.not_listed_count || 0})`}</Text>
                  </InlineStack>
                </BlockStack>
              </BlockStack>
            </div>
          } dismissOnMouseOut>
            <span className={getClass({
              "Custom--listed-Product-Badge": true,
              "Custom--listed-Product-Badge-windows": navigator.userAgent.includes('Windows')
            })}>
              <Badge progress='incomplete' >{t(badge?.['label'])}</Badge>
            </span>
            <span className={badge?.emptyStatus ? 'Custom--Empty-Icon Custom--not-listed-icon' : 'Custom_Icon Custom--not-listed-icon'}></span>
          </Tooltip>
        );
      else {
        renderBadge = <Tooltip content={
          <div style={{ width: "130px" }}>
            <BlockStack gap="200">
              <BlockStack gap="100">
                <Text as='p' fontWeight='semibold'>{t("BADGE_INFO")}</Text>
                <InlineStack gap="100" blockAlign='center'>
                  <Text as='span'>{t('SIMPLE_NOT_LISTER')}</Text>
                </InlineStack>
              </BlockStack>
            </BlockStack>
          </div>
        } dismissOnMouseOut>
          <Badge progress='incomplete' >{t(badge?.['label'])}</Badge>
        </Tooltip>
      }
      break;

    case 'Uploaded':
      renderBadge = (
        <Tooltip content={t("This product was uploaded successfully. Please wait for Amazon to process your product data. Check the 'Amazon Sync Status' after a few hours to move the product to the Listed category. Or, wait for the daily product sync to update the status.")} dismissOnMouseOut>
          <Badge tone='info' progress='complete'>{t(badge?.['label'])}</Badge>
        </Tooltip>
      );
      break;

    case 'Partial Uploaded':
      renderBadge = (
        <Tooltip content={t('Some of the variants of this product has been accepted by Amazon, and we are awaiting for thier status update.')} dismissOnMouseOut>
          <Badge tone="info" progress='partiallyComplete'>{t(badge?.['label'])}</Badge>
        </Tooltip>
      );
      break;

    case 'Inactive':
      renderBadge = (
        <Tooltip
          content={
            <div style={{ width: "130px" }}>
              <BlockStack gap="200">
                <BlockStack gap="100">
                  <Text as="p" fontWeight="semibold">
                    {t("BADGE_INFO")}
                  </Text>
                  <InlineStack gap="100" blockAlign="center">
                    <Text as="span">{t('INFO_INACTIVE')}</Text>
                  </InlineStack>
                </BlockStack>
              </BlockStack>
            </div>
          }
          dismissOnMouseOut
        >
          <Badge tone="critical">{t(badge?.['label'])}</Badge>
        </Tooltip>
      );
      break; ``

    case 'Active':
      renderBadge = (
        <Tooltip
          content={
            <div style={{ width: "130px" }}>
              <BlockStack gap="200">
                <BlockStack gap="100">
                  <Text as="p" fontWeight="semibold">
                    {t("BADGE_INFO")}
                  </Text>
                  <InlineStack gap="100" blockAlign="center">
                    <Text as="span">{t('INFO_ACTIVE')}</Text>
                  </InlineStack>
                </BlockStack>
              </BlockStack>
            </div>
          }
          dismissOnMouseOut
        >
          <Badge tone="success">{t(badge?.['label'])}</Badge>
        </Tooltip>
      );
      break;

    case 'Not Listed: Offer':
      renderBadge = (
        <Tooltip
          content={
            <div style={{ width: "130px" }}>
              <BlockStack gap="200">
                <BlockStack gap="100">
                  <Text as="p" fontWeight="semibold">
                    {t("BADGE_INFO")}
                  </Text>
                  <InlineStack gap="100" blockAlign="center">
                    <Text as="span">{t('INFO_NOT_LISTER_OFFER')}</Text>
                  </InlineStack>
                </BlockStack>
              </BlockStack>
            </div>
          }
          dismissOnMouseOut
        >
          <Badge tone="new">{t(badge?.['label'])}</Badge>
        </Tooltip>
      );
      break;
    case 'Incomplete':
      renderBadge = (
        <Tooltip
          content={
            <div style={{ width: "130px" }}>
              <BlockStack gap="200">
                <BlockStack gap="100">
                  <Text as="p" fontWeight="semibold">
                    {t("BADGE_INFO")}
                  </Text>
                  <InlineStack gap="100" blockAlign="center">
                    <Text as="span">{t('INFO_INCOMPLETE')}</Text>
                  </InlineStack>
                </BlockStack>
              </BlockStack>
            </div>
          }
          dismissOnMouseOut
        >
          <Badge tone="warning">{t(badge?.['label'])}</Badge>
        </Tooltip>
      );
      break;
    case 'Ready To Upload':
      renderBadge = (
        <Badge tone="magic">{t(badge?.['label'])}</Badge>
      );
      break;

  }
  return renderBadge;
}


export default DI(ListingGrid);

// Function to get the latest time in the array
export const getLatestTime = (times: string[]) => {
  // Parse all valid date-time strings into Date objects
  const dateTimes: any = times
    .map(time => {
      // Attempt to create a Date object from each time string
      const date = new Date(time);
      // Check if it's a valid date
      return isNaN(date.getTime()) ? null : date;
    })
    .filter(date => date !== null); // Filter out invalid dates

  // Get the latest date from the array
  if (dateTimes.length > 0) {
    return new Date(Math.max(...dateTimes.map((date: any) => date.getTime())));
  }
  return null;
};

// Calculate the time difference in seconds between the latest time and now
export const calculateTimeDifference = (latestTime: any) => {
  if (!latestTime) return null;

  const currentTime: any = new Date();
  const timeDifference = Math.abs(currentTime - latestTime); // Difference in milliseconds

  const hours = Math.floor(timeDifference / (1000 * 60 * 60));
  const minutes = Math.floor(timeDifference / 1000 / 60); // Get the whole minutes
  const seconds = Math.floor((timeDifference / 1000) % 60); // Get the remaining seconds

  return { hours, minutes, seconds };
};

